import { ColumnDef } from "@tanstack/react-table"
import { LocationsQuery } from "~/__generated__/graphql"
import { Link } from "react-router-dom"
import { Button } from "~/ui/button"
import { adminLocationsPath } from "~/common/paths" // Import admin path helper

type Location = NonNullable<NonNullable<LocationsQuery["locations"]["edges"][0]>["node"]>
type LocationTableData = Location | null | undefined

export const columns: ColumnDef<LocationTableData>[] = [
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => row.original?.name ?? "",
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => row.original?.status ?? "",
  },
  {
    accessorKey: "websiteUrl",
    header: "Website",
    cell: ({ row }) =>
      row.original?.websiteUrl ? (
        <a
          href={row.original.websiteUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800"
        >
          Visit
        </a>
      ) : null,
  },
  {
    accessorKey: "googleMapsUrl",
    header: "Google Maps",
    cell: ({ row }) =>
      row.original?.googleMapsUrl ? (
        <a
          href={row.original.googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800"
        >
          View
        </a>
      ) : null,
  },
  {
    accessorKey: "createdAt",
    header: "Created",
    cell: ({ row }) =>
      row.original?.createdAt ? new Date(row.original.createdAt).toLocaleDateString() : "",
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) =>
      row.original && (
        <div className="flex gap-2">
          {/* Admin View Link (Optional - can link to user view or an admin-specific view if created) */}
          <Link to={`/locations/${row.original.id}`}>
            <Button variant="outline" size="sm">
              View
            </Button>
          </Link>
          {/* Admin Edit Link */}
          <Link to={`${adminLocationsPath({})}/${row.original.id}/edit`}>
            <Button variant="outline" size="sm">
              Edit
            </Button>
          </Link>
        </div>
      ),
  },
]
